
import logo from '@/assets/img/logo.png';
import { ConfigProvider, Spin } from 'antd';
import locale from 'antd/lib/locale/zh_CN';
import 'moment/locale/zh-cn';
import React, { Suspense } from 'react';
import { Provider } from 'react-redux';
import { renderRoutes } from 'react-router-config';
import { HashRouter } from 'react-router-dom';
import './App.less';
import routes from './router';
import store from './store/index';

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

window.logo = logo

function App() {
	return (
		<div>
			<ConfigProvider locale={locale}>
				<Provider store={store}>
					<HashRouter>
						<Suspense fallback={<Spin />}>{renderRoutes(routes)}</Suspense>
					</HashRouter>
				</Provider>
			</ConfigProvider>
		</div>
	);
}

export default App;
